import HeadDirection from './HeadDirection'
import { AnimationComponentProps as Props } from './phaseAnimation'

export default function HeadDown(props: Props) {
  return <HeadDirection direction="down" {...props} />
}
